module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('text-input', {
    attrs: {
      "id": "name",
      "placeholder": "Sprint name"
    },
    on: {
      "input": _vm.nameChanged
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2364ca37"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sprint/SprintName.vue
// module id = 543
// module chunks = 1